import React, { Component } from 'react';
import { Menu, Dropdown, Layout, message } from 'antd';
import { MenuUnfoldOutlined, UserOutlined, DownOutlined } from '@ant-design/icons';
import { Redirect } from 'react-router-dom';
import bus from '@utils/bus';
import { logout } from '@api/login'; 

const { Header } = Layout;

export default class HeaderCustom extends Component {
    state = {
        user: '',
        visible: false,
        isRedirect: false
    };

    handleClickIcon() {
        bus.dispatch('menuToggle')
        bus.dispatch('echarts_resize')
    };

    handleDropOut() {
        logout().then(res => {
            if(res.data.meta.errCode === 0){
                message.success('退出成功!')
            }
            this.setState({
                isRedirect: true
            });
            bus.userInfo = null
            bus.me = null
        })
    };

    render() {
        const menu = (
            <Menu>
              {/* <Menu.Divider /> */}
              <Menu.Item key="out" onClick={this.handleDropOut.bind(this)}>退出</Menu.Item>
            </Menu>
        );

        if (this.state.isRedirect) {
            return <Redirect to={'/login'} />;
        }

        const name = bus.userInfo ? (bus.userInfo.name ? bus.userInfo.name : bus.userInfo.mobile) : '--'
        return (
            <Header style={{ background: '#fff', padding: 0, position: 'fixed', zIndex: 1000, width: '100%' }}>
                <MenuUnfoldOutlined
                    className="trigger"
                    onClick={this.handleClickIcon.bind(this)}
                />
                <div className="header_user_info">
                    <UserOutlined />
                    <Dropdown overlay={menu} trigger={['click']}>
                        <span className="ant-dropdown-link">
                            {name} <DownOutlined />
                        </span>
                    </Dropdown>
                </div>
            </Header>
        );
    }
}
